import { Component, Host, Prop, h } from '@stencil/core';

import { onFireDREvent } from '../../../actions/actions.offer';
import { trackAppointmentRequestTopClick } from '../../../tracking/tracking.dealer';
import { BrowserUtils } from '../../../utils/utils.browser';

@Component({
  tag: 'offer-further-review-need-inspection',
  styleUrl: 'offer-further-review-need-inspection.css',
})
export class OfferFurtherReviewNeedInspection {
  @Prop() offerExpiryDate: string = '';
  @Prop() isAssigned: boolean = false;
  @Prop() offerId: string = '';
  @Prop() email: string = '';
  @Prop() zipCode: string = '';
  @Prop() dealerName: string = '';
  @Prop() vehicleShortDescription: string = '';
  @Prop() vehicleImageLocation: string = '';
  @Prop() whenAppointmentRequested = () => {};
  @Prop() whenReviewVehicleDetailsClicked: (evt: MouseEvent) => void = () => {};
  @Prop() showOfferPriceButton: boolean = false;
  @Prop() useTradeIn: boolean = false;
  @Prop() tradeInBtnText: string = '';
  @Prop() showFurtherReviewTextWithoutDealerName: boolean = true;

  onReviewClick(evt: MouseEvent) {
    evt.preventDefault();
    this.whenReviewVehicleDetailsClicked(evt);
  }

  handleAppointmentRequestClick = () => {
    trackAppointmentRequestTopClick();

    this.whenAppointmentRequested();
  };

  render() {
    const { offerId, email, zipCode, tradeInBtnText, offerExpiryDate, vehicleShortDescription, vehicleImageLocation, showOfferPriceButton, useTradeIn } = this;
    return (
      <Host>
        <div>
          <h2 class="mb-4">
            To confidently give you an Instant Cash Offer, we need to see your vehicle. Please call {this.isAssigned ? this.dealerName : `a Participating Dealer`} to make an
            appointment.
          </h2>

          <div class="mb-4">
            When you arrive for your appointment, the dealer will inspect your vehicle using the same questions you just answered - and will take you step-by-step through the
            results.
          </div>

          <div class="mb-4">We look forward to seeing you.</div>
          <div>
            <div class="font-bold">Why does the dealer need to inspect my vehicle?</div>
            We may need to review the condition of certain items before making an offer. Additionally, specific equipment, particularly vehicle modifications, may require special
            consideration.
          </div>
        </div>

        <offer-hurricane-warning zipCode={zipCode} isInspectionNeeded={true} />

        <div class="flex flex-col md:flex-row justify-between">
          <div class="text-center md:text-left mt-8">
            <div class="font-bold">{vehicleShortDescription}</div>
            <div>
              <a href="#" class="no-underline" onClick={(evt) => this.onReviewClick(evt)}>
                Review vehicle details
              </a>
            </div>
            {vehicleImageLocation && (
              <div>
                <img class="w-80" src={vehicleImageLocation} />
              </div>
            )}
          </div>

          <div class="text-center md:text-right text-xs xs:mt-4 md:mt-8">
            {offerExpiryDate && <div class="text-clrs-argo-red font-semibold">Offer good until: {offerExpiryDate}</div>}
            <offer-short-description shouldDisplay={BrowserUtils.IS_MOBILE} offerId={offerId} email={email} zipCode={zipCode} />
            <div class="flex flex-wrap justify-center md:justify-end w-full mt-8 gap-4">
              {showOfferPriceButton && <ico-button buttonStyle="secondary" label="Request Appointment" whenClicked={this.handleAppointmentRequestClick} />}

              {useTradeIn && <ico-button buttonStyle="secondary" label={tradeInBtnText} whenClicked={onFireDREvent.bind(this, tradeInBtnText)} />}
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
